import { render, staticRenderFns } from "./DtReclamacoes.vue?vue&type=template&id=5eef04ee"
import script from "./DtReclamacoes.vue?vue&type=script&lang=js"
export * from "./DtReclamacoes.vue?vue&type=script&lang=js"
import style0 from "./DtReclamacoes.vue?vue&type=style&index=0&id=5eef04ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports